var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('img',{attrs:{"src":_vm.url,"width":_vm.width,"alt":_vm.name}}):_c('span',{staticClass:"initials",style:({ background: _vm.background, height: _vm.width + 'px', width: _vm.width + 'px' }),domProps:{"textContent":_vm._s(_vm.initials)}})
}
var staticRenderFns = []

export { render, staticRenderFns }